'use client';
import { cn, getProxyImage } from '@/lib/utils';
import { SquareArrowOutUpRight } from 'lucide-react';
import Link from 'next/link';
import { ITab } from '../indexMain';
import { ShadowbanUserPostResult } from './type';
import { useTranslation } from 'next-i18next';
import styles from './card.module.less';

export default function Card({
  data,
  platform,
}: {
  data: ShadowbanUserPostResult;
  platform: ITab['tab'];
}) {
  const { t } = useTranslation();
  const dateTime = new Date(data.publish_time);
  const timeResult = dateTime.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });

  const isSafe = data.risk === 'Low';
  const img1Show =
    (platform === 'instagram' || platform === 'tiktok') && data.image_url;
  const img2Show = platform === 'twitter' && data.image_url;
  return (
    <div className={styles.card}>
      {img1Show && (
        <img
          className={cn(
            platform === 'instagram' ? styles.imageInstagram : styles.imageTikTok
          )}
          src={getProxyImage(data?.image_url || '', platform)}
          alt=""
        />
      )}

      <div className={styles.content}>
        <div className={styles.statusRow}>
          <span
            className={cn(
              styles.riskScore,
              isSafe ? styles.safe : styles.danger
            )}
          >
            {isSafe ? t('Low') : t('High')}
          </span>
        </div>
        <div className={styles.postContent}>
          {img2Show && (
            <img
              className={styles.imageTwitter}
              src={data?.image_url || ''}
              alt=""
            />
          )}
          <div className={styles.text}>
            {data.content}
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.timestamp}>
            {timeResult}
          </div>
          <Link
            className={styles.viewLink}
            href={data.post_url}
          >
            {t('View Post')}
            <SquareArrowOutUpRight className={styles.linkIcon} size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
}
